import ApiClient from './ApiClient';

class ProductsAPI extends ApiClient {
  constructor() {
    super('products', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(productId) {
    return axios.get(`${this.url}/${productId}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(productId, data) {
    return axios.patch(`${this.url}/${productId}`, data);
  }

  delete(productId) {
    return axios.delete(`${this.url}/${productId}`);
  }

  // Gallery
  addGalleryImage(productId, formData) {
    return axios.post(`${this.url}/${productId}/add_gallery_image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removeGalleryImage(productId, imageId) {
    return axios.delete(
      `${this.url}/${productId}/remove_gallery_image?image_id=${imageId}`
    );
  }

  // Subitems
  getSubitems(productId) {
    return axios.get(`${this.url}/${productId}/subitems`);
  }

  createSubitem(productId, data) {
    return axios.post(`${this.url}/${productId}/subitems`, data);
  }

  updateSubitem(productId, subitemId, data) {
    return axios.patch(`${this.url}/${productId}/subitems/${subitemId}`, data);
  }

  deleteSubitem(productId, subitemId) {
    return axios.delete(`${this.url}/${productId}/subitems/${subitemId}`);
  }

  reorderSubitems(productId, positions) {
    return axios.post(`${this.url}/${productId}/subitems/reorder`, {
      positions,
    });
  }
}

export default new ProductsAPI();
